export const toHex = (amount: number): string => '0x' + amount.toString(16);
